module.exports = __webpack_public_path__ + "static/media/work (9).7e818ad8.jpg";